module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "dark-top",
    attrs: {
      "dialog": "modal-lg",
      "footer": true
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h2', [_vm._v("Terms of Service & Privacy Policy")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "col-sm-12 mt-2 d-flex justify-content-end",
    staticStyle: {
      "margin-bottom": "-1.5rem"
    }
  }, [_c('div', {
    staticClass: "langPicker"
  }, [_c('v-select', {
    attrs: {
      "options": _vm.languagesAvailable
    },
    model: {
      value: (_vm.selectedLanguage),
      callback: function($$v) {
        _vm.selectedLanguage = $$v
      },
      expression: "selectedLanguage"
    }
  })], 1)]), _vm._v(" "), _c(_vm.selectedLanguage.lang, {
    tag: "span"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center justify-content-between",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn cancel wider mr-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Ok")])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-2263708c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2263708c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/TosConditions.vue
// module id = 1327
// module chunks = 0